import React, { useState, useEffect } from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { countryService } from '../../services/country-service'
import CountryList from '../../components/country-list'
import AddEditCountry from '../../components/add-edit-country'

const Country = () => {
  const [countries, setCountries] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [count, setCount] = useState(0)
  const [open, setOpen] = useState(false)

  const navigate = useNavigate()

  const fetchCountries = async () => {
    try {
      const response = await countryService.fetch(rowsPerPage, rowsPerPage * page)
      setCountries(response.data)
      setCount(response.total)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchCountries()
  }, [rowsPerPage, page])

  const handleSubmit = async (data) => {
    try {
      await countryService.create(data)
      fetchCountries()
      setOpen(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button sx={{ textTransform: 'none', backgroundColor: '#DC585C' }} onClick={() => setOpen(true)}>
          <Typography fontFamily={'poppins'} fontSize={'14px'} fontWeight={500} color="#fff">
            Add
          </Typography>
        </Button>
      </Box>

      <CountryList
        onSuccess={fetchCountries}
        data={countries}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={(event, newPage) => setPage(newPage)}
        handleChangeRowsPerPage={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10))
          setPage(0)
        }}
      />

      {/* Pass handleSubmit and fetchCountries from parent */}
      <AddEditCountry open={open} setOpen={setOpen} handleSubmit={handleSubmit} />
    </>
  )
}

export default Country
